import React from 'react'
import Favicon from 'react-favicon'

const TabController = (props) => (
  <Favicon url={props.iconUrl} />
)

export default TabController
